/**
 * Copyright 2019 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
'use memo';
import type { ContentStackHeaderPromo } from '@/features/contentstack/interface';
import { SmartLink as Link } from '@/utils/smartLink';
import DeviceWrapper from '@/components/AZCustomComponent/DeviceWrapper';
import styles from './styles.module.scss';

export type HeaderPromoProps = {
  content: ContentStackHeaderPromo;
};

export const HeaderPromo = ({ content }: HeaderPromoProps) => {
  const { ad } = content;
  const [ad1, ad2] = ad ?? ([] as Array<NonNullable<ContentStackHeaderPromo['ad']>[0] | undefined>);

  const title = ad1?.text_content?.replace(/\n/g, '');
  const label = ad2?.text_content?.replace(/\n/g, '');

  const link = ad1?.cta_link || ad2?.cta_link;
  const linkAltText = ad1?.cta_name || ad2?.cta_name || undefined;

  const dynamicContent = (
    <div className={styles.dynamicContent}>
      <div
        className={styles.title}
        id="header-promo-title"
        dangerouslySetInnerHTML={{ __html: title ?? '' }}
      />
      <div
        className={styles.label}
        id="header-promo-label"
        dangerouslySetInnerHTML={{ __html: label ?? '' }}
      />
    </div>
  );

  return (
    <DeviceWrapper desktop tablet mobile>
      {link ? (
        <Link to={link} ariaLabel={linkAltText}>
          {dynamicContent}
        </Link>
      ) : (
        dynamicContent
      )}
    </DeviceWrapper>
  );
};
